export default __webpack_public_path__ + "img/total-darklogo.4fefab9c.png";